import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=2c2d0f6a&"
import script from "./AddMenu.vue?vue&type=script&lang=js&"
export * from "./AddMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports